import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-unsaved-modal',
    templateUrl: './unsaved-modal.component.html',
    styleUrls: ['./unsaved-modal.component.scss'],
    standalone: false
})
export class UnsavedModalComponent {
  constructor(public activeModal: NgbActiveModal) {}

  isValidForm: boolean;
  confirm() {
    this.activeModal.close('yes');
  }

  cancel(isDiscard:boolean) {
    if(isDiscard) this.activeModal.close('no');
    else this.activeModal.close('dismissed')
  }
}
